module.exports = __webpack_public_path__ + "static/img_9387-711b26f0afc4417b1532af96aecaa992.webp";